export default "__VITE_ASSET__BhoXr97x__"